import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { TimelineFilters } from '@/forms/TimelineFilterForm/types';
import { ActivityLog } from '@/types/activityLog';
import PaginatedResponse from '@/types/paginatedResponse';
import { PaginationParams } from '@/types/pagination';
import ajax from '@/utils/ajax';

type TimelineParams = Partial<TimelineFilters> & PaginationParams;

export const activityLogsRepository = {
  async getActivityLogsForPerson({
    host,
    personId,
    params
  }: {
    host: string;
    personId: string;
    params: TimelineParams;
  }): Promise<PaginatedResponse<ActivityLog[]>> {
    try {
      const path = '/api/dugout/events/';
      const response = await ajax.get({
        url: `${host}${path}`,
        params: {
          ...params,
          person_id: personId
        }
      });

      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getActivityLogByFormAnswerGroupId({
    host,
    formAnswerGroupHealthieId
  }: {
    host: string;
    formAnswerGroupHealthieId: string;
  }): Promise<ActivityLog> {
    try {
      const path = `/api/dugout/events/${formAnswerGroupHealthieId}/by_form_answer_group_healthie_id/`;
      const response = await ajax.get({
        url: `${host}${path}`
      });

      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getUniqueEventNames({ host }: { host: string }): Promise<string[]> {
    try {
      const path = '/api/dugout/events/list_actions/';
      const response = await ajax.get({
        url: `${host}${path}`
      });

      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

const ActivityLogsRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getActivityLogsForPerson(
      personId: string,
      params: TimelineParams
    ): Promise<PaginatedResponse<ActivityLog[]>> {
      return activityLogsRepository.getActivityLogsForPerson({ host, personId, params });
    },

    async getActivityLogByFormAnswerGroupId(formAnswerGroupHealthieId: string) {
      return activityLogsRepository.getActivityLogByFormAnswerGroupId({
        host,
        formAnswerGroupHealthieId
      });
    },

    async getUniqueEventNames(): Promise<string[]> {
      return activityLogsRepository.getUniqueEventNames({ host });
    }
  };
};

export default ActivityLogsRepository;
